import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'

import './globals.css'
import App from './App'
import './i18n'

// Security cleanup: older builds persisted the login password in plaintext under
// the "user" localStorage key (naive remember-me). Wipe any lingering password
// on every boot — the remembered email is kept, the password never is.
try {
  const raw = localStorage.getItem('user')
  if (raw) {
    const u = JSON.parse(raw)
    if (u && u.password) {
      if (u.email) localStorage.setItem('user', JSON.stringify({ email: u.email }))
      else localStorage.removeItem('user')
    }
  }
} catch (_e) {
  localStorage.removeItem('user')
}

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <Suspense fallback={null}>
    <App />
  </Suspense>,
)
